/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import {
    fork, takeEvery, call, put,
} from 'redux-saga/effects';

import mbpLogger from '@module-logger/mbp';

import {
    subscriptionOptIn,
    setSubscriptionMessage,
} from './Subscription-Action';
import orderClient from '../../../../../../../apis/checkout-apis/orderClient';

import { checkJWT } from '../../../Global/Global-Operations';

const createSubscriptionOptIn = ({
    JWT_TOKEN,
    optInEntryObj,
}) => orderClient.createOptInEntry({}, JWT_TOKEN, optInEntryObj);

function* submitSubscriptionOptIn(action) {
    try {
        const JWT_TOKEN = yield call(checkJWT);
        const { data } = action;
        const subscriptionOptInResult = yield call(createSubscriptionOptIn, {
            JWT_TOKEN,
            optInEntryObj: data,
        });
        yield put(setSubscriptionMessage(subscriptionOptInResult.data));
    } catch (ex) {
        mbpLogger.logError({
            function: 'addSubscribeOptIn',
            appName: process.env.npm_package_name,
            module: 'mbp-pwa-ui',
            message: 'addSubscribeOptIn - Error',
            jsError: ex,
        });
        console.log(ex);
    }
}

function* watchSubcriptionOptIn() {
    yield takeEvery(subscriptionOptIn().type, submitSubscriptionOptIn);
}

const watchers = [
    fork(watchSubcriptionOptIn),
];

export {
    watchers,
    subscriptionOptIn,
};
export default {};
